// import path from 'path';
import React, { Component } from 'react';
import PT from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import FiltersHeader from '../../../app/components/FiltersHeader';
import DataTable from '../../components/DataTable';
import TableControls from '../../components/TableControls';
import { selectControlsState } from '../../../store/reducers/tableControls';
import ButtonMenu from '../../components/FilterComponents/ButtonMenu';
import { FilterMenuOptionsType } from '../../../lib/proptypes/semantic';
import { DataPT } from '../../components/DataTable/DataTable.proptypes';
import ColGroupsType from '../../../lib/proptypes/colGroups';
import { positionToTitle } from '../../../lib/lookups';
import {
  selectPositionsForFilterMenu,
  getColGroups,
} from '../../../store/reducers/positions';
import { clearSelectedPlayers } from '../../../store/reducers/tableControls';
import { goToView } from '../../routes.global';
import {
  SEASON_STATS_VIEW,
  selectSeasonStatsState,
  SEASON_POSITION_STATS_MAP_KEY,
} from './module/seasonStats';
import classes from './Season.css';
import {
  selectToolDescriptionsState,
} from '../../../store/reducers/toolDescriptions';
import { ToolDescription } from '../../components/ToolDescriptions/ToolDescriptions';
import { gciPageView } from '../../../lib/analytics';

// const log = debug('huddle:app:views:season');
const pageTitle = 'Season-To-Date';

const statTypeOptions = [
  { name: 'REGULAR SEASON', value: 'REGULAR SEASON' },
  { name: 'POSTSEASON', value: 'POSTSEASON' },
];

const mapStateToProps = state => {
  const {
    position,
    year,
    formulaId,
    seasonType,
    stats,
    hasLoaded,
  } = selectSeasonStatsState(state);
  const {
    toolDescriptions,
    toolsLoaded,
  } = selectToolDescriptionsState(state);

  return {
    hasLoaded,
    selectedPosition: position,
    selectedYear: year,
    selectedProfile: formulaId,
    selectedSeasonType: seasonType,
    collapsed: selectControlsState(state).collapsed,
    positions: selectPositionsForFilterMenu(state, 'stats'),
    ...hasLoaded && {
      tableData: stats,
      colGroups: getColGroups(state, SEASON_POSITION_STATS_MAP_KEY, position),
    toolDescriptions,
    toolsLoaded,
    },
  };
};
const actions = {
  goToView,
  clearSelectedPlayers,
};

class Season extends Component {
  static propTypes = {
    hasLoaded: PT.bool.isRequired,
    selectedYear: PT.number.isRequired,
    selectedProfile: PT.number.isRequired,
    selectedPosition: PT.string.isRequired,
    selectedSeasonType: PT.string.isRequired,
    positions: FilterMenuOptionsType.isRequired,
    tableData: DataPT,
    goToView: PT.func.isRequired,
    colGroups: ColGroupsType,
    clearSelectedPlayers: PT.func.isRequired,
    toolsLoaded: PT.bool.isRequired,
    gciPageView: PT.func.isRequired,
  }

  static defaultProps = {
    tableData: [],
    colGroups: [],
  }

  componentWillMount() {
    this.props.clearSelectedPlayers();
  }

  handleChangeYear = (event, { value }) => {
    if (this.props.selectedYear !== value) {
      gciPageView(pageTitle);
      this.props.goToView(SEASON_STATS_VIEW, { query: { year: value } });
    }
  }

  handleChangeProfile = (event, { value }) => {
    if (this.props.selectedProfile !== value) {
      gciPageView(pageTitle);
      this.props.goToView(SEASON_STATS_VIEW, { query: { formulaId: value } });
    }
  }

  handleChangePosition = (event, { value }) => {
    if (this.props.selectedPosition !== value) {
      gciPageView(pageTitle);
      this.props.goToView(SEASON_STATS_VIEW, { query: { position: value } });
    }
    document.title = pageTitle + ': ' + positionToTitle(value, { capitalize: true, plural: true }) + ' - TheHuddle';
  }

  handleChangeSeasonType = (event, { value }) => {
    if (this.props.selectedSeasonType !== value) {
      gciPageView(pageTitle);
      this.props.goToView(SEASON_STATS_VIEW, { query: { seasonType: value } });
    }
  }

  setPageTitle = () => {
    document.title = pageTitle + ': ' + positionToTitle(this.props.selectedPosition, { capitalize: true, plural: true }) + ' - TheHuddle';
  }

  render() {
    const {
      tableData,
      positions,
      selectedYear,
      selectedProfile,
      selectedPosition,
      selectedSeasonType,
      hasLoaded,
      colGroups,
      toolDescriptions,
      toolsLoaded,
    } = this.props;

    return (
      <div className={classes.wrapper}>
        <FiltersHeader
          title={`Season-To-Date: ${positionToTitle(selectedPosition, { capitalize: true, plural: true })}`}
          description={toolsLoaded && toolDescriptions.tool_descriptions.season_stats.visible == 1 && (
            <ToolDescription
              descr={toolDescriptions.tool_descriptions.season_stats.text}
            />)}
          seasonType="seasons"
          statType="stats"
          selectedYear={selectedYear}
          selectedProfile={selectedProfile}
          onChangeProfile={this.handleChangeProfile}
          onChangeYear={this.handleChangeYear}
        >
          <ButtonMenu
            choices={positions}
            label={'Position:'}
            activeItem={selectedPosition}
            onChange={this.handleChangePosition}
          />
          <ButtonMenu
            choices={statTypeOptions}
            label={'Stat Type:'}
            activeItem={selectedSeasonType}
            onChange={this.handleChangeSeasonType}
          />
        </FiltersHeader>
        <TableControls
          injury
          track
          compare
          colGroups={colGroups}
        />
        {hasLoaded &&
          <DataTable
            className={this.props.collapsed ? classes.collapsed : ''}
            track
            compare
            injury
            selectedLeague={selectedProfile}
            colGroups={colGroups}
            data={tableData}
          />
        }
      </div>
    );
  }

  componentDidMount() {
    this.setPageTitle();
    gciPageView(pageTitle);
  }

  componentDidUpdate() {
    this.setPageTitle();
    // gciPageView(pageTitle);
  }
}

export default connect(mapStateToProps, actions)(Season);



// WEBPACK FOOTER //
// ./src/app/views/Season/Season.js